let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6lxEU")).then(() => parcelRequire('cNx0r'));